export const SPELLS = [
    // --- CANTRIPS (LEVEL 0) ---
    {
        name: "Acid Splash",
        level: 0,
        school: "Conjuration",
        classes: ["Sorcerer", "Wizard", "Druid"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Hurl a bubble of acid. 1d6 Acid damage to creatures in 5ft radius sphere."
    },
    {
        name: "Blade Ward",
        level: 0,
        school: "Abjuration",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "1 round",
        description: "Impose Disadvantage on attack rolls against you until the start of your next turn."
    },
    {
        name: "Fire Bolt",
        level: 0,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Instantaneous",
        description: "Hurl a mote of fire. 1d10 Fire damage on hit."
    },
    {
        name: "Guidance",
        level: 0,
        school: "Divination",
        classes: ["Cleric", "Druid"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Concentration, up to 1 minute",
        description: "Target adds 1d4 to one Ability Check of its choice."
    },
    {
        name: "Light",
        level: 0,
        school: "Evocation",
        classes: ["Bard", "Cleric", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "1 hour",
        description: "Object sheds bright light in 20ft radius and dim light for an additional 20ft."
    },
    {
        name: "Mage Hand",
        level: 0,
        school: "Conjuration",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "1 minute",
        description: "Spectral hand can manipulate objects (up to 10 lbs)."
    },
    {
        name: "Chill Touch",
        level: 0,
        school: "Necromancy",
        classes: ["Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "1 round",
        description: "1d8 Necrotic damage. Target can't regain HP. Undead has Disadvantage on attacks against you."
    },
    {
        name: "Dancing Lights",
        level: 0,
        school: "Evocation",
        classes: ["Bard", "Sorcerer", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Concentration, up to 1 minute",
        description: "Create four torch-sized lights that shed dim light."
    },
    {
        name: "Druidcraft",
        level: 0,
        school: "Transmutation",
        classes: ["Druid"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "Instantaneous",
        description: "Create tiny sensory effect, light/snuff candle, bloom flower, or predict weather."
    },
    {
        name: "Eldritch Blast",
        level: 0,
        school: "Evocation",
        classes: ["Warlock"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Instantaneous",
        description: "Beam deals 1d10 Force damage. Higher Levels: More beams."
    },
    {
        name: "Mending",
        level: 0,
        school: "Transmutation",
        classes: ["Bard", "Cleric", "Druid", "Sorcerer", "Wizard", "Artificer"],
        castingTime: "1 Minute",
        range: "Touch",
        duration: "Instantaneous",
        description: "Repair a single break/tear in an object."
    },
    {
        name: "Message",
        level: 0,
        school: "Transmutation",
        classes: ["Bard", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "1 round",
        description: "Whisper a message to a creature. It can reply."
    },
    {
        name: "Minor Illusion",
        level: 0,
        school: "Illusion",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "1 minute",
        description: "Create a sound or an image of an object."
    },
    {
        name: "Poison Spray",
        level: 0,
        school: "Conjuration",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "10 feet",
        duration: "Instantaneous",
        description: "1d12 Poison damage (Con Save)."
    },
    {
        name: "Prestidigitation",
        level: 0,
        school: "Transmutation",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "10 feet",
        duration: "1 hour",
        description: "Perform minor magical tricks (clean, soil, flavor, light, etc.)."
    },
    {
        name: "Ray of Frost",
        level: 0,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "1d8 Cold damage. Slow speed by 10ft."
    },
    {
        name: "Shocking Grasp",
        level: 0,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Instantaneous",
        description: "1d8 Lightning damage. Target can't take reactions. Advantage if metal armor."
    },
    {
        name: "Thaumaturgy",
        level: 0,
        school: "Transmutation",
        classes: ["Cleric"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "1 minute",
        description: "Create minor supernatural manifestations (tremors, loud voice, dim/brighten flames)."
    },
    {
        name: "True Strike",
        level: 0,
        school: "Divination",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "Concentration, up to 1 round",
        description: "Advantage on your next attack roll against target. (2014 version, 2024 changed)."
    },
    {
        name: "Vicious Mockery",
        level: 0,
        school: "Enchantment",
        classes: ["Bard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "1d4 Psychic damage and Disadvantage on next attack roll (Wis Save)."
    },

    // --- LEVEL 1 ---
    {
        name: "Bless",
        level: 1,
        school: "Enchantment",
        classes: ["Cleric", "Paladin"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "Concentration, up to 1 minute",
        description: "Up to 3 creatures add 1d4 to Attack Rolls and Saving Throws."
    },
    {
        name: "Burning Hands",
        level: 1,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self (15-foot cone)",
        duration: "Instantaneous",
        description: "3d6 Fire damage (Dex Save for half). Ignites flammable objects."
    },
    {
        name: "Cure Wounds",
        level: 1,
        school: "Evocation",
        classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Instantaneous",
        description: "Heal 2d8 + Spellcasting Mod hit points." // 2024 buff: 1d8 -> 2d8
    },
    {
        name: "Detect Magic",
        level: 1,
        school: "Divination",
        classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "Concentration, up to 10 minutes",
        description: "Sense presence of magic within 30 feet."
    },
    {
        name: "Faerie Fire",
        level: 1,
        school: "Evocation",
        classes: ["Bard", "Druid", "Artificer"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 1 minute",
        description: "Objects in 20ft cube outlined in light. Advantage on attacks vs them. No invisibility."
    },
    {
        name: "Healing Word",
        level: 1,
        school: "Evocation",
        classes: ["Bard", "Cleric", "Druid"],
        castingTime: "1 Bonus Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Heal 2d4 + Spellcasting Mod hit points." // 2024 buff: 1d4 -> 2d4
    },
    {
        name: "Magic Missile",
        level: 1,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Instantaneous",
        description: "Three darts deal 1d4+1 Force damage each. No attack roll needed."
    },
    {
        name: "Shield",
        level: 1,
        school: "Abjuration",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Reaction",
        range: "Self",
        duration: "1 round",
        description: "+5 AC until start of next turn. Blocks Magic Missile."
    },
    {
        name: "Sleep",
        level: 1,
        school: "Enchantment",
        classes: ["Bard", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "1 minute",
        description: "Creatures in 5ft radius sphere fall asleep (Wis Save). No HP checking in 2024. Higher Levels: Radius increases."
    },

    // --- LEVEL 2 ---
    {
        name: "Darkness",
        level: 2,
        school: "Evocation",
        classes: ["Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 10 minutes",
        description: "15ft radius sphere of magical darkness."
    },
    {
        name: "Invisibility",
        level: 2,
        school: "Illusion",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Concentration, up to 1 hour",
        description: "Creature becomes invisible. Higher Levels: Target +1 additional creature for each slot level above 2nd."
    },
    {
        name: "Misty Step",
        level: 2,
        school: "Conjuration",
        classes: ["Sorcerer", "Warlock", "Wizard", "Druid"],
        castingTime: "1 Bonus Action",
        range: "Self",
        duration: "Instantaneous",
        description: "Teleport 30 feet to an unoccupied space you can see."
    },
    {
        name: "Scorching Ray",
        level: 2,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Instantaneous",
        description: "Hurl 3 rays of fire. 2d6 Fire per ray. Higher Levels: +1 ray for each slot level above 2nd."
    },
    {
        name: "Shatter",
        level: 2,
        school: "Evocation",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Loud noise in 10ft radius. 3d8 Thunder damage. Higher Levels: +1d8 damage for each slot level above 2nd."
    },
    {
        name: "Web",
        level: 2,
        school: "Conjuration",
        classes: ["Sorcerer", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 1 hour",
        description: "Create sticky webs in 20ft cube. Restrains creatures (Dex Save)."
    },

    // --- LEVEL 3 ---
    {
        name: "Counterspell",
        level: 3,
        school: "Abjuration",
        classes: ["Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Reaction",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Interrupt a spell. Higher Levels: Auto-succeed vs spells of the slot level used or lower."
    },
    {
        name: "Fireball",
        level: 3,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "150 feet",
        duration: "Instantaneous",
        description: "20ft radius explosion. 8d6 Fire damage. Higher Levels: +1d6 damage for each slot level above 3rd."
    },
    {
        name: "Fly",
        level: 3,
        school: "Transmutation",
        classes: ["Sorcerer", "Warlock", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Concentration, up to 10 minutes",
        description: "Target gains flying speed 60ft. Higher Levels: Target +1 creature for each slot level above 3rd."
    },
    {
        name: "Revivify",
        level: 3,
        school: "Necromancy",
        classes: ["Cleric", "Paladin", "Ranger", "Druid", "Artificer"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Instantaneous",
        description: "Return life to creature died within last minute. 1 HP."
    },
    // --- LEVEL 4 ---
    {
        name: "Arcane Eye",
        level: 4,
        school: "Divination",
        classes: ["Cleric", "Wizard", "Artificer"],
        castingTime: "1 Action",
        range: "30 feet",
        duration: "Concentration, up to 1 hour",
        description: "Create an invisible eye to scout."
    },
    {
        name: "Banishment",
        level: 4,
        school: "Abjuration",
        classes: ["Cleric", "Paladin", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 1 minute",
        description: "Banish a creature to another plane (Cha Save)."
    },
    {
        name: "Dimension Door",
        level: 4,
        school: "Conjuration",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "500 feet",
        duration: "Instantaneous",
        description: "Teleport yourself and one willing creature to a spot you can see/visualize."
    },
    {
        name: "Greater Invisibility",
        level: 4,
        school: "Illusion",
        classes: ["Bard", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Concentration, up to 1 minute",
        description: "Creature becomes invisible and stays invisible after attacking."
    },
    {
        name: "Polymorph",
        level: 4,
        school: "Transmutation",
        classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 1 hour",
        description: "Transform a creature into a beast (Wis Save)."
    },
    {
        name: "Wall of Fire",
        level: 4,
        school: "Evocation",
        classes: ["Druid", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Concentration, up to 1 minute",
        description: "Create a wall of fire. 5d8 Fire damage (Dex Save half). Higher Levels: +1d8 damage."
    },

    // --- LEVEL 5 ---
    {
        name: "Cone of Cold",
        level: 5,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self (60-foot cone)",
        duration: "Instantaneous",
        description: "8d8 Cold damage (Con Save half). Higher Levels: +1d8 damage."
    },
    {
        name: "Greater Restoration",
        level: 5,
        school: "Abjuration",
        classes: ["Bard", "Cleric", "Druid", "Celestrial Warlock"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Instantaneous",
        description: "End charm, petrification, curse, stat reduction, or max HP reduction."
    },
    {
        name: "Hold Monster",
        level: 5,
        school: "Enchantment",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "90 feet",
        duration: "Concentration, up to 1 minute",
        description: "Paralyze a creature (Wis Save). Higher Levels: +1 target."
    },
    {
        name: "Mass Cure Wounds",
        level: 5,
        school: "Evocation",
        classes: ["Bard", "Cleric", "Druid"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Heal 3d8 + Mod to 6 creatures in 30ft sphere. Higher Levels: +1d8 healing."
    },
    {
        name: "Wall of Force",
        level: 5,
        school: "Evocation",
        classes: ["Wizard"],
        castingTime: "1 Action",
        range: "120 feet",
        duration: "Concentration, up to 10 minutes",
        description: "Invisible, indestructible wall."
    },

    // --- LEVEL 6 ---
    {
        name: "Chain Lightning",
        level: 6,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "150 feet",
        duration: "Instantaneous",
        description: "10d8 Lightning to target + 3 bolts to others (Dex Save half). Higher Levels: +1 bolt."
    },
    {
        name: "Disintegrate",
        level: 6,
        school: "Transmutation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "10d6+40 Force damage. Dust on 0 HP. Destroys Large nonmagical objects/force creations. (Dex Save)"
    },
    {
        name: "Globe of Invulnerability",
        level: 6,
        school: "Abjuration",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self (10-foot radius)",
        duration: "Concentration, up to 1 minute",
        description: "Barrier blocks spells of 5th level or lower."
    },
    {
        name: "Heal",
        level: 6,
        school: "Evocation",
        classes: ["Cleric", "Druid"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Heal 70 HP. End Blindness, Deafness, Disease. Higher Levels: +10 HP."
    },
    {
        name: "Sunbeam",
        level: 6,
        school: "Evocation",
        classes: ["Druid", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self (60-foot line)",
        duration: "Concentration, up to 1 minute",
        description: "6d8 Radiant + Blindness (Con Save). Repeatable action."
    },

    // --- LEVEL 7 ---
    {
        name: "Crown of Stars",
        level: 7,
        school: "Evocation",
        classes: ["Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "1 hour",
        description: "7 motes. BA to fire for 4d12 Radiant. Higher Levels: +2 motes."
    },
    {
        name: "Delayed Blast Fireball",
        level: 7,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "150 feet",
        duration: "Concentration, up to 1 minute",
        description: "12d6 Fire base, +1d6 per turn held. (Dex Save half)."
    },
    {
        name: "Finger of Death",
        level: 7,
        school: "Necromancy",
        classes: ["Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "7d8+30 Necrotic. Humanoid killed rises as Zombie."
    },
    {
        name: "Plane Shift",
        level: 7,
        school: "Conjuration",
        classes: ["Cleric", "Druid", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "Touch",
        duration: "Instantaneous",
        description: "Travel to another plane or banish creature (Cha Save)."
    },
    {
        name: "Resurrection",
        level: 7,
        school: "Necromancy",
        classes: ["Bard", "Cleric"],
        castingTime: "1 Hour",
        range: "Touch",
        duration: "Instantaneous",
        description: "Return dead creature (century). Penalties if not used carefully."
    },
    {
        name: "Teleport",
        level: 7,
        school: "Conjuration",
        classes: ["Bard", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "10 feet",
        duration: "Instantaneous",
        description: "Instant travel for you + 8 creatures anywhere on plane. Mishap chance."
    },

    // --- LEVEL 8 ---
    {
        name: "Antimagic Field",
        level: 8,
        school: "Abjuration",
        classes: ["Cleric", "Wizard"],
        castingTime: "1 Action",
        range: "Self (10-foot radius)",
        duration: "Concentration, up to 1 hour",
        description: "Spells and magic items fail within field."
    },
    {
        name: "Dominate Monster",
        level: 8,
        school: "Enchantment",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Concentration, up to 1 hour",
        description: "Control any creature (Wis Save)."
    },
    {
        name: "Feeblemind",
        level: 8,
        school: "Enchantment",
        classes: ["Bard", "Druid", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "150 feet",
        duration: "Instantaneous",
        description: "4d6 Psychic. Int/Cha become 1. (Int Save)."
    },
    {
        name: "Sunburst",
        level: 8,
        school: "Evocation",
        classes: ["Druid", "Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "150 feet",
        duration: "Instantaneous",
        description: "60ft radius. 12d6 Radiant + Blindness (Con Save)."
    },

    // --- LEVEL 9 ---
    {
        name: "Foresight",
        level: 9,
        school: "Divination",
        classes: ["Bard", "Druid", "Warlock", "Wizard"],
        castingTime: "1 Minute",
        range: "Touch",
        duration: "8 hours",
        description: "Advantage on everything. Disadvantage on attacks against target."
    },
    {
        name: "Mass Heal",
        level: 9,
        school: "Evocation",
        classes: ["Cleric"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "700 HP divided among creatures. Cures diseases/blindness/deafness."
    },
    {
        name: "Meteor Swarm",
        level: 9,
        school: "Evocation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "1 mile",
        duration: "Instantaneous",
        description: "Four 40ft radius meteors. 20d6 Fire + 20d6 Bludgeoning each (Dex Save half)."
    },
    {
        name: "Power Word Kill",
        level: 9,
        school: "Enchantment",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
        castingTime: "1 Action",
        range: "60 feet",
        duration: "Instantaneous",
        description: "Target with < 100 HP dies instantly. No save."
    },
    {
        name: "Shapechange",
        level: 9,
        school: "Transmutation",
        classes: ["Druid", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "Concentration, up to 1 hour",
        description: "Transform into any creature (Level/CR restriction). Gain abilities."
    },
    {
        name: "Time Stop",
        level: 9,
        school: "Transmutation",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "Instantaneous",
        description: "Take 1d4 + 1 turns in a row. Ends if you interact with another creature."
    },
    {
        name: "True Resurrection",
        level: 9,
        school: "Necromancy",
        classes: ["Cleric", "Druid"],
        castingTime: "1 Hour",
        range: "Touch",
        duration: "Instantaneous",
        description: "Resurrect any creature died < 200 years ago, full HP, cures everything."
    },
    {
        name: "Wish",
        level: 9,
        school: "Conjuration",
        classes: ["Sorcerer", "Wizard"],
        castingTime: "1 Action",
        range: "Self",
        duration: "Instantaneous",
        description: "Duplicate any spell 8th level or lower, or other mighty effects. Stress chance."
    }
];
